"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Chevron = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var classes = _ref.classes;
  return /*#__PURE__*/_react.default.createElement("svg", {
    className: (0, _classnames.default)('icon', 'icon--chevron', classes),
    viewBox: "0 0 8 14",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    ref: ref
  }, /*#__PURE__*/_react.default.createElement("title", null, "Chevron Icon"), /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react.default.createElement("g", {
    transform: "translate(-569.000000, -51.000000)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M578.094812,54.2411537 C578.513911,53.8220545 579.193406,53.8220545 579.612505,54.2411537 C580.001668,54.6303173 580.029466,55.244005 579.695897,55.6652435 L579.612505,55.7588463 L573.758846,61.6125048 C573.369683,62.0016684 572.755995,62.0294658 572.334757,61.695897 L572.241154,61.6125048 L566.387495,55.7588463 C565.968396,55.3397471 565.968396,54.6602529 566.387495,54.2411537 C566.776659,53.8519901 567.390346,53.8241927 567.811585,54.1577615 L567.905188,54.2411537 L573,59.3365854 L578.094812,54.2411537 Z",
    id: "Chevron",
    transform: "translate(573.000000, 57.926829) rotate(-90.000000) translate(-573.000000, -57.926829) "
  }))));
});
Chevron.displayName = 'IconChevron';
Chevron.propTypes = {
  classes: _propTypes.default.string
};
Chevron.defaultProps = {
  classes: ''
};
var _default = Chevron;
exports.default = _default;